// ページごとに読み込まれるファイル
export default class Project {
  constructor(args) {
    // code
    console.log('project.js loaded')
    this.initialize()
  }

  initialize() {
  }

  // methods

}



// WEBPACK FOOTER //
// ./pages/project.js